<template>
    <div>
        <label for="tipo">Tipo</label>
        <select @input="$emit('input', $event.target.value)" required="required" name="tipo" id="tipo">
            <option v-for="tipo in tipos" :value="tipo.name">{{tipo.name}}</option>
        </select>
        <i class="bar"></i>
    </div>
</template>

<script>
    export default {
        name: "Tipo",
        data(){
            return{
                tipos:[
                    {value:'',name:''},
                    {value: "0", name:'Venta'},
                    {value: "1", name:'Encargo'},
                    {value: "2", name:'Stock'}

                ]
            }
        }
    }
</script>

<style scoped>
    label{
        font-weight: bold;
        display: block;
    }
    select{
        width: 100%;
        height: 30px;
        cursor: pointer;
    }

</style>
